export * from './IconDrillingRig';
